export class Constants
{
    public static readonly Calendar = class Calendar
    {
        public static readonly DAY_NAMES_SHORT = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        public static readonly DAY_NAMES_LONG = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        public static readonly MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        public static readonly MONTH_NAMES_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    }

    public static readonly TeamNames = class TeamNames
    {
        public static readonly ADMINISTRATION_SYSTEM_USERS = "Administration System Users";
        public static readonly SYSTEM_ADMINISTRATORS = "System Administrators";
    }
}